'use strict';
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dSettings$0024$0024anon$00241 from "./app.data.-General-Practice-User-Settings$$anon$1.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserSettings(defaultPharmacyRange, maximumPharmacyRange) {
  this.Lapp_data_GeneralPracticeUserSettings__f_defaultPharmacyRange = 0;
  this.Lapp_data_GeneralPracticeUserSettings__f_maximumPharmacyRange = 0;
  this.Lapp_data_GeneralPracticeUserSettings__f_defaultPharmacyRange = defaultPharmacyRange;
  this.Lapp_data_GeneralPracticeUserSettings__f_maximumPharmacyRange = maximumPharmacyRange;
}
export { $c_Lapp_data_GeneralPracticeUserSettings as $c_Lapp_data_GeneralPracticeUserSettings };
$c_Lapp_data_GeneralPracticeUserSettings.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserSettings.prototype.constructor = $c_Lapp_data_GeneralPracticeUserSettings;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserSettings() {
}
export { $h_Lapp_data_GeneralPracticeUserSettings as $h_Lapp_data_GeneralPracticeUserSettings };
$h_Lapp_data_GeneralPracticeUserSettings.prototype = $c_Lapp_data_GeneralPracticeUserSettings.prototype;
$c_Lapp_data_GeneralPracticeUserSettings.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_GeneralPracticeUserSettings.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1713637009), true);
});
$c_Lapp_data_GeneralPracticeUserSettings.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_GeneralPracticeUserSettings) && ((this.Lapp_data_GeneralPracticeUserSettings__f_defaultPharmacyRange === x$0.Lapp_data_GeneralPracticeUserSettings__f_defaultPharmacyRange) && (this.Lapp_data_GeneralPracticeUserSettings__f_maximumPharmacyRange === x$0.Lapp_data_GeneralPracticeUserSettings__f_maximumPharmacyRange))));
});
$c_Lapp_data_GeneralPracticeUserSettings.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_GeneralPracticeUserSettings.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_data_GeneralPracticeUserSettings.prototype.productPrefix__T = (function() {
  return "GeneralPracticeUserSettings";
});
$c_Lapp_data_GeneralPracticeUserSettings.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_GeneralPracticeUserSettings__f_defaultPharmacyRange;
  }
  if ((n === 1)) {
    return this.Lapp_data_GeneralPracticeUserSettings__f_maximumPharmacyRange;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_GeneralPracticeUserSettings.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "defaultPharmacyRange";
  }
  if ((n === 1)) {
    return "maximumPharmacyRange";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_GeneralPracticeUserSettings.prototype.toForm__Lapp_data_GeneralPracticeUserSettingsForm = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  var suppressWarningsResult$macro$1 = new $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dSettings$0024$0024anon$00241.$c_Lapp_data_GeneralPracticeUserSettings$$anon$1();
  return suppressWarningsResult$macro$1.transform__Lapp_data_GeneralPracticeUserSettings__Lapp_data_GeneralPracticeUserSettingsForm(this);
});
function $isArrayOf_Lapp_data_GeneralPracticeUserSettings(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_GeneralPracticeUserSettings)));
}
export { $isArrayOf_Lapp_data_GeneralPracticeUserSettings as $isArrayOf_Lapp_data_GeneralPracticeUserSettings };
var $d_Lapp_data_GeneralPracticeUserSettings = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserSettings, "app.data.GeneralPracticeUserSettings", ({
  Lapp_data_GeneralPracticeUserSettings: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_GeneralPracticeUserSettings as $d_Lapp_data_GeneralPracticeUserSettings };
//# sourceMappingURL=app.data.-General-Practice-User-Settings.js.map
